<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []
    if (icon) {
      // if(icon && icon.startsWith('iconshuju2')){
      //   let iconArr = icon.split(' ');
      //   vnodes.push(<a href={`/details/${iconArr[1]}`} target="_blank" style="display:inline-block;width:15px;position:absolute;"><i class={iconArr[0]}/></a>)
      // }else{
      //   vnodes.push(<i class={icon}/>)
      // }
      vnodes.push(<i class={icon}/>)
    }

    if (title) {
      vnodes.push(<span class='menu-text menu-text1' slot='title'>{( title)}</span>)
    }
    return vnodes
  }
}
</script>
